import React from 'react';
import {
	withScriptjs,
	withGoogleMap,
	GoogleMap,
	Marker,
	Polyline,
} from 'react-google-maps';
import { graphql, compose, Query } from 'react-apollo';
import polyline from '@mapbox/polyline';
import color from 'src/config/color';
import detailShipmentQuery from './graphql/query/detailShipment';
import googleMapsKey from 'src/config/googleMapsKey';
import { MarkerTime, InfoWindowTime } from './components';
import moment from 'moment';
import 'moment-duration-format';
import { withNamespaces } from 'react-i18next';
import client from 'src/config/client';
import firebase from 'firebase';
import firebaseConfig from 'src/config/firebaseConfig';
import axios from 'axios';
import mapuri from 'src/config/mapuri';

const pickupIcon = `data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAA0CAYAAADi1poDAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAppJREFUeNrMWEuOozAQJUn3ZKZXHMGLrLLiCByBIzA34AjcgHVWzA2YA0QikUaa7Mh+FuQEgdUsppuudo0cyQLb2MFu8qQnlA/2c1XZVWXPswfizYiIMqesKEHAhrKkTFwK9SlTNhkYEsWFti1yj5A+C7awScgtCOm7M5BNthhxUal6GbHZbC7b7bZdr9ctfm6aJtjv961G7Hyn/GFimUK2SkII7Ha75nq9NiDB6XSq4zges1agKyYVDeD7PmRZBiao6xrCMFS5bzSmApmYqqrgXiisVYwJKm2L0RAVGlmnKAqwARrwEASBkZUGWxz9bxNlWcqsJIyl2pV1eEisFIuS4yB2XAB3qkAQesdbqrI1XYmTpCgZl/QFDXxI48eJINW4y94Omx28oEP/x7ZtnUx6uVy0BA1wPp+dCFKNywsa/OtwODix0vF4FOrUOodMk6kO8DgRbPtIJCgTlRp45NtCmqZGWZ+IjnVMijaACVpindy4ZM3z3FVihbHqksgKejT3vZZRiMl0NkIsKzsx+5vURrgIiZuA9XXaXYiy24ii6L8bsUQVlRhJkqiE3ALZuIm03QJptUJjSCyLqWy017FFMb6tEz95JDFTY2pSzIyhukNQ5LKGIoY3IZn3CdCNp9pF3Gh3uCYdqZNaXeNy6tOh2nWzXIISiZh8zs4lfxTryGKpfIT+rlZdGsyBhEsR1jrXKbh1vT+9B0Jtw11PE617I953/6L8TbmmfGcE9tTGylDEgi0CJ/1K+Y3xhfIv5R/2G/KZjX+7nAfdCUyAk3xhfOaeT9zi3ihfOf7j2Nl02aLHJfdcsbGAc1MneMdqDAFbPe+Cjn235HbsO/c9b6nOhcv4gF4x8oHt9SzUcQHuuRSkGgemDPQhwAC3qLvGM4GyJgAAAABJRU5ErkJggg==`;
const deliveryIcon = `data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAA0CAYAAADi1poDAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA4tJREFUeNrMWE1oE0EUnt02Fi2mSxE81J94UNCDNBfx1gjiwZMFoYpgE89CU+hBPajxoD0IRvBsW0G0ILQHTyI0vYh4SfCgoAejtYeCyDaxlZpk47zyFsfJzO7s7qz1wWPSMvP2m2++N/NmCNFgH/cfssB1xDJCfHyQNqPUoc1IupWoV6jPHPz8oRILIAokS5sb1FMB51ClXqDAprUAQkamkJEoBkzl/BgzFVgpawBDMEaZxsyHYogOBFayXoO7LKvaM3iUmL07YFmIs7ae2qi8JS3b9lvWacpUThkQzuKekNJkkvRdGLGT50dIYt9eYWY1vizZtSezZPXxrOXUajJQoKubvoAoGMicBVEE69Io6c9f3gSlYgDme/EBsR/OyLqcoKBKUkC4l5RFmbT77iTZeXY4lHjqz+bIysQVWQamKShbJuq8bjBgMBZiCCyF35Rm2ZhomaKAYUElxXHGhIAwxS1ewKAZXbbr+jWR/iz8dgdDQ3xPmJGqgFUMYklYGhIByoho1m2SmBkRoA4x9xw5rB2QJGbK9+jYfvwYicu8YpvM/vNf2CYgdmP6s8vWY/uoV2zpkm28ex8bIK/YJlev/GVrL15qByOJWREBKvG9avQM0m2SmCURoEXRbH6+fqMNDMSSMLQoO+0/8fsR7BsDTx9F3rGhFFk+d1GknypNqgMyURdEAvx263ZkdiCGRMwFvwJNWEP3njpJS4g7gZkCZlYmrkrFTNlJ+6U91Lq2SE9Lp88EyjyfMTZ+S6mmzuLVR2iJPQOkj9ZJcATwZxMsC4h3lZatja/LXnhzorua4XMFmoppb8zJLo6Gz70MyoI5vnCLYLBMw3xhH+bmuqABlI23jErkuz2CKkcElFZ5eDBVImGgXETNKL2CmKoRUYTFEGCKqi8fYd+Hgjw+dGx82hjiNs44+oYDhFooKHQtBH09C8sQQS3ZPikeRm/hAGENPu7RZVxUp8ciar/6ia9v/tWSSesnRX3FBmie05KN/9saQKgTFsB8WO3oYgjsvuT31hmIGwUe2bo1YSrpmlx3hKU2sDV/OM4r99ZEvQ21PeOxAurCMQlswc3n63X3iIAiroXeRG/g323dGyOA2cZ4gnF3Yi0GxC/0BtNqZcjg3ESQrruTc9jl5Ma0dQJqMbN0ddJEMCYDxmFYaiI7zTiWjBU0y47JxGEF7WopkLANTdnKxmlHCfRbgAEAE2xXcf+7pL4AAAAASUVORK5CYII=`;
const driverIcon = `data:image/png;base64,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`;
const pinDeliveryIconRoundTrip = `data:image/png;base64,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`;

const GoogleMapsWrapper = withScriptjs(
	withGoogleMap(props => (
		<GoogleMap
			{...props}
			ref={c => {
				props.onMapMounted && props.onMapMounted(c);
			}}
		>
			{props.children}
		</GoogleMap>
	)),
);

const google = window.google = window.google ? window.google : {}

class GoogleMaps extends React.Component {
	constructor(props, context) {
		super(props);
		this.state = {
			fitBounds: true,
			isTracking: false,
			polyline: {
				distance: 0,
				duration: 0,
				coordinates: [],
			},
			polylineList: [],
			trackingLatitude: 0,
			trackingLongitude: 0,
		};

		if (!firebase.apps.length) {
			firebase.initializeApp(firebaseConfig);
		}
	}

	componentDidMount() {
		this.polylineListDecode();
		this.getGpsData();
	}
	
	getGpsData = async () => {
		try {
			const { data } = await client.query({
				query: detailShipmentQuery,
				variables: {
					_id: this.props.shipmentId
				},
				fetchPolicy: "network-only"
			});

			const driverId = data.shipmentList.shipment[0].driver_user_id;
			firebase
				.database()
				.ref(`/gps/${driverId}`).limitToLast(1)
				.on("value", async (snapshot) => {
					if (snapshot.numChildren() === 1) {
						snapshot.forEach(child => {
							const val = child.val();
							this.setState({
								trackingLatitude: val.location.coords.latitude,
								trackingLongitude: val.location.coords.longitude,
							}, async () => {
								const data = await this.fetchPolyline();
								const {
									polyline: polylineEncode,
									duration,
									distance,
								} = data;
								
								if(polylineEncode === null) {
									this.setState({ polyline: {
										distance: 0,
										duration: 0,
										coordinates: [],
									}});

									return;
								}

								this.polylineDecode(polylineEncode, duration, distance);					
							});
						});
					}
				});
		} catch (error) {
			console.log(error);
		}
	}

	fitBounds(shipmentAddress) {
		const {
			trackingLatitude,
			trackingLongitude,
		} = this.state;

		const shipmentListFilter =  shipmentAddress.map((item, index) => ({ ...item, index })).filter(item => item.mode !== 'roundtrip');	
		if(shipmentListFilter.length > 0) {
			const bounds = new window.google.maps.LatLngBounds();
			shipmentListFilter.forEach((item, index) => {
				bounds.extend(
					new window.google.maps.LatLng(Number(item.lat), Number(item.lng)),
				);
			});

			if (trackingLatitude !== 0 && trackingLongitude !== 0) {
				bounds.extend(
					new window.google.maps.LatLng(
						trackingLatitude,
						trackingLongitude,
					),
				);
			}

			if (this.state.fitBounds) {
				this._map.fitBounds(bounds);
				this.setState({
					fitBounds: false,
				});
			}
		}
	}

	getMarker(shipmentAddress) {
		const shipmentListFilter = shipmentAddress.map((item, index) => ({ ...item, index })).filter(item => item.mode !== 'roundtrip');	
		const shipmentRoundTrip = shipmentAddress.filter(item => item.mode === 'roundtrip');

		if(shipmentListFilter.length > 0) {
			if (google.maps === undefined) {
				return shipmentListFilter.map((item, index) => (
					<Marker
						key={index}
						icon={{
							url: item.mode === 'รับสินค้า' || item.mode === 'รับตู้หนัก' || item.mode === 'รับตู้เบา' ? pickupIcon : deliveryIcon,
						}}

						position={{
							lat: parseFloat(item.lat),
							lng: parseFloat(item.lng),
						}}
					/>
				));
			}

			return shipmentListFilter.map((item, index) => {
				if(shipmentRoundTrip.length > 0 && item.mode === 'ส่งสินค้า') {
					return (
						<Marker
							key={index}
							icon={{
								labelOrigin: new google.maps.Point(43, 64),
								url: pinDeliveryIconRoundTrip,
							}}
							position={{
								lat: parseFloat(item.lat),
								lng: parseFloat(item.lng),
							}}
							label={{
								color: '#000000',
								fontWeight: 'bold',
								fontSize: '14px',
								lineHeight: '20px',
								text: (item.index + 1).toString(),
							}}
						/>
					)
				}

				return (
					<Marker
						key={index}
						icon={{
							labelOrigin: new google.maps.Point(19, 16),
							url: item.mode === 'รับสินค้า' || item.mode === 'รับตู้หนัก' || item.mode === 'รับตู้เบา' ? pickupIcon : deliveryIcon,
						}}
						position={{
							lat: parseFloat(item.lat),
							lng: parseFloat(item.lng),
						}}
						label={{
							color: '#000000',
							fontWeight: 'bold',
							fontSize: '14px',
							lineHeight: '20px',
							text: (item.index + 1).toString(),
						}}
					/>
				)
			});
		}

		return null;
	}

	getDriverMarker = () => {
		const {
			trackingLatitude,
			trackingLongitude,
		} = this.state;

		if(trackingLatitude !== 0 && trackingLongitude !== 0) {

			return (
				<React.Fragment>
					<Marker
						icon={{
							url: driverIcon,
						}}
						position={{
							lat: Number(this.state.trackingLatitude),
							lng: Number(this.state.trackingLongitude),
						}}
					>
						{
						this.state.polyline.coordinates.length >= 2 && (
							<InfoWindowTime
								title={this.getFormatTime(this.state.polyline.duration)}
								subTitle={`${this.props.t('common:googleMap.distance')} ${this.state.polyline.distance.toLocaleString('en-US', {maximumFractionDigits:2})} ${this.props.t('common:googleMap.km')}`}
								lat={Number(this.state.trackingLatitude)}
								lng={Number(this.state.trackingLongitude)}
								/>
						)
					}
					</Marker>
				</React.Fragment>
			)
		}

		return null;
	}

	getPolyline(shipment) {
		const {
			shipment_type,
			tracking_drop,
			shipment_status
		} = shipment;

		return (
			<React.Fragment>
				{/* polyline shipment detail */}
				{/* duration shipment detail */}
				{ shipment_type === 1 && shipment_status !== 4 && shipment_status !== 5 && shipment_status !== 6 &&
					this.props.isHideDriver &&
					tracking_drop === null
					? this.state.polylineList.map((item, index) => (
							<React.Fragment>
								<Polyline
									key={index}
									path={item.coordinates}
									options={{
										strokeColor: color.Blue,
										strokeWeight: 6,
									}}
								/>

								{
									this.state.polylineList
									.filter(item => item.coordinates.length >= 2)
									.map((item, index) => (
										<MarkerTime
											key={index}
											title={this.getFormatTime(item.duration)}
											subTitle={`${this.props.t('common:googleMap.distance')} ${item.distance.toLocaleString('en-US', {maximumFractionDigits:2})} ${this.props.t('common:googleMap.km')}`}
											lat={this.getLatLngPolylineCenter(item.coordinates).lat}
											lng={this.getLatLngPolylineCenter(item.coordinates).lng}
										/>
									))
								}
							</React.Fragment>
						))
					: null
				}

				{/* polyline socket io */}
				{/* duration socket io */}
				{shipment_type === 1 &&
				!this.props.isHideDriver &&
				tracking_drop === null &&
				this.state.polyline.coordinates.length >= 2 ? (
					<React.Fragment>
						<Polyline
							path={this.state.polyline.coordinates}
							options={{
								strokeColor: color.Blue,
								strokeWeight: 6,
							}}
						/>
					</React.Fragment>
				) : null}
			</React.Fragment>
		);
	}

	polylineDecode(polylineEncode, duration, distance) {
		try {
			this.setState({
				polyline: {
					duration,
					distance,
					coordinates: polyline.decode(polylineEncode).map(point => {
						return {
							lat: point[0],
							lng: point[1],
						};
					}),
				},
			});
		} catch (error) {
			console.log(error);
		}
	}

	async fetchPolyline() {
		try {
			const {
				trackingLatitude,
				trackingLongitude,
			} = this.state;
	
			const param = {
				lat: trackingLatitude,
				lng: trackingLongitude,
				shipment_id: this.props.shipmentId,	 
			};
	
			const res = await axios.post(`${mapuri}/driver-track-polyline`, param)
			return res.data;
		} catch(error) {
			console.log(error);
		}

		return null;
	}

	async polylineListDecode() {
		try {
			const { data } = await client.query({
				query: detailShipmentQuery,
				variables: {
					_id: this.props.shipmentId
				},
				fetchPolicy: 'network-only',
			});

			const polylineListEncode =
				data.shipmentList.shipment[0].polyline_list;

			const polylineListDecode = polylineListEncode.map(polylineEncode => ({
				duration: polylineEncode.duration,
				distance: polylineEncode.distance,
				coordinates: polyline.decode(polylineEncode.polyline).map(point => {
					return {
						lat: point[0],
						lng: point[1],
					};
				}),
			}));

			this.setState({
				polylineList: polylineListDecode,
			});
		} catch (error) {
			console.log(error);
		}
	}

	getLatLngPolylineCenter(coordinates) {
		const coordinateCenterIndex = coordinates.length / 2 - 1;

		return {
			lat: coordinates[Math.floor(coordinateCenterIndex)].lat,
			lng: coordinates[Math.floor(coordinateCenterIndex)].lng,
		};
	}

	getFormatTime(second) {
		return moment
			.duration(second, 'second')
			.format(`D [${this.props.t('common:instancePrice.totalDistance.time.day')}] HH [${this.props.t('common:instancePrice.totalDistance.time.hour')}] mm [${this.props.t('common:instancePrice.totalDistance.time.min')}]`, {
				trunc: true,
				trim: "both"
		});
	}

	render() {
		return (
			<Query
				query={detailShipmentQuery}
				variables={{
					shipmentNumber: this.props.shipmentNumber,
				}}
			>
				{
					({ loading, error, data }) => {
						if(loading) return null;
						if(error) return null;

						return (
							<GoogleMapsWrapper
								loadingElement={<div style={{ height: `100%` }} />}
								containerElement={<div style={{ height: '100%' }} />}
								mapElement={<div style={{ height: `100%` }} />}
								googleMapURL={`https://maps.googleapis.com/maps/api/js?key=${googleMapsKey}&v=3.exp&libraries=geometry,drawing,places`}
								zoom={15}
								options ={{
									"mapTypeControl" :false,
									"panControl" :false,
									"streetViewControl" :false,
									"minZoom" : 5,
									"maxZoom" : 18,
								}}
								defaultCenter={{
									lat: 13.685702,
									lng: 100.611084,
								}}
								onIdle={() => this.fitBounds(data.shipmentList.shipment[0].shipment_address)}
								onMapMounted={c => (this._map = c)}
							>
								{ this.getMarker(data.shipmentList.shipment[0].shipment_address) }
								{ this.getPolyline(data.shipmentList.shipment[0]) }
								{ !this.props.isHideDriver && this.getDriverMarker() }
							</GoogleMapsWrapper>
						)
					}
				}
			</Query>
		);
	}
}

export default compose(
	graphql(
		detailShipmentQuery, {
			name: 'detailShipmentQuery',
			options: props => ({
				fetchPolicy: 'cache-and-network',
				variables: {
					_id: props.shipmentId,
				},
			}),
		},
	),
)(withNamespaces()(GoogleMaps));
